import {
  GET_PAYORGANIZERS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  payOrganizers: [],
  error: {},
};

const PayOrganizer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PAYORGANIZERS:
          return {
            ...state,
            payOrganizers: action.payload.data,
            isPayOrganizerSuccess: true
          };
        
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_PAYORGANIZERS:
          return {
            ...state,
            error: action.payload.error,
            isPayOrganizerSuccess: false
          };
        
        default:
          return { ...state };
      }

    default:
      return { ...state };
  }
};

export default PayOrganizer;
